import type { CatDefinition } from '@/types';

/** Cosmetic cat roster. Add new entries here to make a cat selectable everywhere
 * (Cat Select screen, save/unlock system, gameplay rendering) with no other code changes. */
export const CATS: CatDefinition[] = [
  {
    id: 'snowball',
    name: 'Snowball',
    furColor: 0xffffff,
    bellyColor: 0xf3f0ff,
    accentColor: 0xff9ecb,
    pattern: 'solid',
    unlockedByDefault: true,
    price: 0,
  },
  {
    id: 'midnight',
    name: 'Midnight',
    furColor: 0x2b2b3a,
    bellyColor: 0x4d4d63,
    accentColor: 0x8ee3ff,
    pattern: 'solid',
    unlockedByDefault: true,
    price: 0,
  },
  {
    id: 'marmalade',
    name: 'Marmalade',
    furColor: 0xff9d42,
    bellyColor: 0xffe4c2,
    accentColor: 0xff5f5f,
    pattern: 'tabby',
    unlockedByDefault: false,
    price: 150,
  },
  {
    id: 'ash',
    name: 'Ash',
    furColor: 0x9aa0ab,
    bellyColor: 0xe4e7ec,
    accentColor: 0xffd166,
    pattern: 'solid',
    unlockedByDefault: false,
    price: 150,
  },
  {
    id: 'cocoa',
    name: 'Cocoa',
    furColor: 0x7a5240,
    bellyColor: 0xd9b58c,
    accentColor: 0xffe08a,
    pattern: 'patched',
    unlockedByDefault: false,
    price: 250,
  },
  {
    id: 'sapphire',
    name: 'Sapphire',
    furColor: 0xece6da,
    bellyColor: 0xffffff,
    accentColor: 0x4b6ea8,
    pattern: 'pointed',
    unlockedByDefault: false,
    price: 300,
  },
  {
    id: 'rumi',
    name: 'Rumi',
    furColor: 0xb9a3e3,
    bellyColor: 0xf0e6ff,
    accentColor: 0xf5c04a,
    pattern: 'solid',
    unlockedByDefault: false,
    price: 300,
  },
];

export function getCatById(id: string): CatDefinition {
  const cat = CATS.find((c) => c.id === id);
  if (!cat) throw new Error(`Unknown cat id: ${id}`);
  return cat;
}
